import { render, staticRenderFns } from "./AgendaPreview.vue?vue&type=template&id=6c535982"
import script from "./AgendaPreview.vue?vue&type=script&lang=js"
export * from "./AgendaPreview.vue?vue&type=script&lang=js"
import style0 from "./AgendaPreview.vue?vue&type=style&index=0&id=6c535982&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports